<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :width="isHPL || isHMM ? '1230px' : '1770px'"
      top="2.6vh"
      :title="title"
      :close-on-click-modal="false"
      destroy-on-close
      class="app-main-inner edi-selector-dialog custom-dialog"
    >
      <template v-if="isHPL">
        <el-button no="CopyBusinessSendConsigneeNotify" type="primary" style="margin: 10px 0 0 15px;" @click="euBolHplCopyDialog.visible = true">{{ $t('SeaExport.CopyBusinessSendConsigneeNotify') }}</el-button>
        <div class="custom-dialog-content" style="width: fit-content; display: flex">
          <div class="vertical-line" />
          <div class="form-section">
            <el-form label-width="120px" label-position="right">
              <div>
                <span class="title">{{ $t('SeaExport.DeclarationInformation') }}</span>
                <el-form-item no="ENSDeclaration" :label="$t('SeaExport.EuroLineENSDeclaration')" style="width: 350px" class="lable-blue">
                  <el-select ref="euEnsFilingTag" v-model="form.euEnsFilingTag" :label="$t('SeaExport.EuroLineENSDeclaration')" placeholder=" " @change="onEuEnsFilingTagChange">
                    <el-option
                      v-for="(item,index) in SeaExportConstants.ENS_DECLARATION_HPL"
                      :key="index"
                      :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item no="supplementaryDeclarant" style="width: 350px">
                  <span
                    slot="label"
                    :class="form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_STRAIGHT_SUPPLEMENTARY.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_SELF.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_MIXED.code ? 'blue' : ''"
                  >
                    {{ $t('SeaExport.SupplementaryDeclarant') }}
                  </span>
                  <el-input ref="supplementaryDeclarantEoriNo" v-model="form.supplementaryDeclarantEoriNo" type="text" :filter-chars="false" @change="onSupplementaryDeclarantChange" />
                </el-form-item>
                <el-form-item no="chemicalType" style="width: 350px">
                  <span slot="label" class="blue" v-html="$t('SeaExport.ChemicalIdentifier')" />
                  <el-select ref="chemicalTag" v-model="form.chemicalTag" no="chemicalTag">
                    <el-option :label="$t('SeaExport.ChemicalProduct')" :value="true" />
                    <el-option :label="$t('SeaExport.NonChemicalProduct')" :value="false" />
                  </el-select>
                </el-form-item>
                <el-form-item no="ucrNo" :label="$t('SeaExport.UCRNO')" style="width: 350px">
                  <el-input ref="ucrNo" v-model="form.ucrNo" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ActualShipperCountry')">
                  <cargo-advance-select
                    ref="shipperCountry"
                    no="shipperCountry"
                    :select-type="TYPE_NAMES.basic_data_Country"
                    filterable
                    tag-name="code"
                    :show-custom-label-in-option="true"
                    :custom-label="p=>`${p.code}（${p.name}）`"
                    :default-value="form.shipperCountry"
                    @parentCallBack="p=>{form.shipperCountry=p.value}"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ShipperEORI')">
                  <el-input ref="shipperIdNumber" v-model="form.shipperIdNumber" no="4" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ActualRecipientCountry')">
                  <cargo-advance-select
                    ref="consigneeCountry"
                    no="consigneeCountry"
                    :select-type="TYPE_NAMES.basic_data_Country"
                    filterable
                    tag-name="code"
                    :show-custom-label-in-option="true"
                    :custom-label="p=>`${p.code}（${p.name}）`"
                    :default-value="form.consigneeCountry"
                    @parentCallBack="p=>{form.consigneeCountry=p.value}"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ConsigneeEORI')">
                  <el-input ref="consigneeId" v-model="form.consigneeId" no="9" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.NotificationCountry')">
                  <cargo-advance-select
                    ref="notifyCountry"
                    no="notifyCountry"
                    :select-type="TYPE_NAMES.basic_data_Country"
                    filterable
                    tag-name="code"
                    :show-custom-label-in-option="true"
                    :custom-label="p=>`${p.code}（${p.name}）`"
                    :default-value="form.notifyCountry"
                    @parentCallBack="p=>{form.notifyCountry=p.value}"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.NotifyEORI')">
                  <el-input ref="notifyCodeForManifest" v-model="form.notifyCodeForManifest" no="14" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item no="factoryIdNumber" :label="$t('SeaExport.FactoryEORI')" style="width: 350px">
                  <el-input ref="factoryIdNumber" v-model="form.factoryIdNumber" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item no="warehouseIdNumber" :label="$t('SeaExport.WarehouseEORI')" style="width: 350px">
                  <el-input ref="warehouseIdNumber" v-model="form.warehouseIdNumber" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item no="lclPersonIdNumber" :label="$t('SeaExport.LCLPersonEORI')" style="width: 350px">
                  <el-input ref="lclPersonIdNumber" v-model="form.lclPersonIdNumber" type="text" :filter-chars="false" />
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="vertical-line" />
          <div class="form-section">
            <el-form label-width="120px" label-position="right">
              <div>
                <template v-if="form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_CARRIER.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_MIXED.code">
                  <span class="title">{{ $t('SeaExport.ActualShipper') }}</span>
                  <el-button no="copyActualShipper" type="primary" class="custom-button" @click="copyActualShipper">{{ $t('SeaExport.CopyActualShipper') }}</el-button>
                  <el-form-item :label="$t('SeaExport.ShipperName')" class="lable-blue" style="width: 400px">
                    <cargo-rich-textarea
                      ref="actualShipperName"
                      v-model="form.actualShipperName"
                      :placeholder="$t('SeaExport.Name')"
                      no="17"
                      :warning-count="warningCount"
                      :is-trim="true"
                      :disable-enter="true"
                      style="min-height: 28px;"
                      @dblclick.native="showNameAddressDialog($t('SeaExport.ActualShipper'), 'actualShipperName', 'actualShipperAddress')"
                    />
                  </el-form-item>
                  <el-form-item style="width: 400px">
                    <span slot="label" class="blue" v-html="$t('SeaExport.ShipperAddress')" />
                    <cargo-rich-textarea
                      ref="actualShipperAddress"
                      v-model="form.actualShipperAddress"
                      no="18"
                      :warning-count="warningCount"
                      :is-trim="true"
                      style="min-height: 70px;"
                      @dblclick.native="showNameAddressDialog($t('SeaExport.ActualShipper'), 'actualShipperName', 'actualShipperAddress')"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.EORICode')" style="width: 400px">
                    <el-input ref="actualShipperCodeForManifest" v-model="form.actualShipperCodeForManifest" no="22" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.ShipperZipCode')" style="width: 400px">
                    <el-input ref="actualShipperPostalCode" v-model="form.actualShipperPostalCode" no="23" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.ActualShipperCountry')" style="width: 400px">
                    <div style="display: flex">
                      <cargo-advance-select
                        ref="actualShipperCountry"
                        no="actualShipperCountry"
                        :select-type="TYPE_NAMES.basic_data_Country"
                        filterable
                        tag-name="code"
                        :show-custom-label-in-option="true"
                        :custom-label="p=>`${p.code}（${p.name}）`"
                        :default-value="form.actualShipperCountry"
                        @parentCallBack="p=>{form.actualShipperCountry=p.value}"
                      />
                      <span style="width: 170px;text-align: center;color: black;">{{ $t('SeaExport.ActualShipperCity') }}</span>
                      <el-input ref="actualShipperCity" v-model="form.actualShipperCity" no="actualShipperCity" type="text" :filter-chars="false" />
                    </div>
                  </el-form-item>
                </template>
                <template v-if="form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_CARRIER.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_MIXED.code">
                  <span class="title">{{ $t('SeaExport.ActualConsignee') }}</span>
                  <el-button no="copyBusiness" type="primary" class="custom-button" @click="copyActualConsignee">{{ $t('SeaExport.CopyActualConsignee') }}</el-button>
                  <el-form-item :label="$t('SeaExport.ConsigneeName')" class="lable-blue" style="width: 400px">
                    <cargo-rich-textarea
                      ref="actualConsigneeName"
                      v-model="form.actualConsigneeName"
                      :placeholder="$t('SeaExport.Name')"
                      no="24"
                      :warning-count="warningCount"
                      :is-trim="true"
                      :disable-enter="true"
                      style="min-height: 28px;"
                      @dblclick.native="showNameAddressDialog($t('SeaExport.ActualConsignee'), 'actualConsigneeName', 'actualConsigneeAddress')"
                    />
                  </el-form-item>
                  <el-form-item style="width: 400px">
                    <span slot="label" class="blue" v-html="$t('SeaExport.ConsigneeAddress')" />
                    <cargo-rich-textarea
                      ref="actualConsigneeAddress"
                      v-model="form.actualConsigneeAddress"
                      no="25"
                      type="textarea"
                      :warning-count="warningCount"
                      :is-trim="true"
                      style="min-height: 70px;"
                      @dblclick.native="showNameAddressDialog($t('SeaExport.ActualConsignee'), 'actualConsigneeName', 'actualConsigneeAddress')"
                    />
                  </el-form-item>
                  <el-form-item
                    v-if="form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_CARRIER.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_MIXED.code"
                    :label="$t('SeaExport.EORICode')"
                    style="width: 400px"
                  >
                    <el-input ref="actualConsigneeIdNumber" v-model="form.actualConsigneeIdNumber" no="29" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.ConsigneeZipCode')" style="width: 400px">
                    <el-input ref="actualConsigneeCodeForManifest" v-model="form.actualConsigneeCodeForManifest" no="30" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.ActualRecipientCountry')" style="width: 400px">
                    <div style="display: flex">
                      <cargo-advance-select
                        ref="actualConsigneeCountry"
                        no="actualConsigneeCountry"
                        :select-type="TYPE_NAMES.basic_data_Country"
                        filterable
                        tag-name="code"
                        :show-custom-label-in-option="true"
                        :custom-label="p=>`${p.code}（${p.name}）`"
                        :default-value="form.actualConsigneeCountry"
                        @parentCallBack="p=>{form.actualConsigneeCountry=p.value}"
                      />
                      <span style="width: 170px;text-align: center;color: black;">{{ $t('SeaExport.ActualRecipientCity') }}</span>
                      <el-input ref="actualConsigneeCity" v-model="form.actualConsigneeCity" no="actualConsigneeCity" type="text" :filter-chars="false" />
                    </div>
                  </el-form-item>
                </template>
              </div>
            </el-form>
          </div>
          <div class="vertical-line" />
          <div v-if="form.euEnsFilingTag !== SeaExportConstants.ENS_DECLARATION_HOUSE_MIXED.code" class="form-section">
            <el-form label-width="120px" label-position="right">
              <div>
                <template v-if="form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_CARRIER.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_MIXED.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_STRAIGHT_CARRIER.code">
                  <span class="title">{{ $t('SeaExport.Buyer') }}</span>
                  <el-form-item :label="$t('SeaExport.BuyerName')" class="lable-blue" style="width: 400px">
                    <cargo-rich-textarea
                      ref="buyerName"
                      v-model="form.buyerName"
                      no="buyerName"
                      :placeholder="$t('SeaExport.Name')"
                      :warning-count="warningCount"
                      :is-trim="true"
                      :disable-enter="true"
                      style="min-height: 28px;"
                      @dblclick.native="showNameAddressDialog($t('SeaExport.Buyer'), 'buyerName', 'buyerAddress')"
                    />
                  </el-form-item>
                  <el-form-item style="width: 400px">
                    <span slot="label" class="blue" v-html="$t('SeaExport.BuyerAddress')" />
                    <cargo-rich-textarea
                      ref="buyerAddress"
                      v-model="form.buyerAddress"
                      no="buyerAddress"
                      :warning-count="warningCount"
                      :is-trim="true"
                      style="min-height: 70px;"
                      @dblclick.native="showNameAddressDialog($t('SeaExport.Buyer'), 'buyerName', 'buyerAddress')"
                    />
                  </el-form-item>
                  <el-form-item
                    v-if="form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_CARRIER.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_STRAIGHT_CARRIER.code"
                    :label="$t('SeaExport.EORICode')"
                    style="width: 400px"
                  >
                    <el-input ref="buyerIdNumber" v-model="form.buyerIdNumber" no="buyerIdNumber" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.BuyerPostalCode')" style="width: 400px">
                    <el-input ref="buyerPostalCode" v-model="form.buyerPostalCode" no="buyerPostalCode" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.BuyerCountry')" style="width: 400px">
                    <div style="display: flex">
                      <cargo-advance-select
                        ref="buyerCountry"
                        no="buyerCountry"
                        :select-type="TYPE_NAMES.basic_data_Country"
                        filterable
                        tag-name="code"
                        :show-custom-label-in-option="true"
                        :custom-label="p=>`${p.code}（${p.name}）`"
                        :default-value="form.buyerCountry"
                        @parentCallBack="p=>{form.buyerCountry=p.value}"
                      />
                      <span style="width: 170px;text-align: center;color: black;">{{ $t('SeaExport.BuyerCity') }}</span>
                      <el-input ref="buyerCity" v-model="form.buyerCity" no="buyerCity" type="text" :filter-chars="false" />
                    </div>
                  </el-form-item>
                </template>
                <template v-if="form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_CARRIER.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_MIXED.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_STRAIGHT_CARRIER.code">
                  <span class="title">{{ $t('RailwayExport.BoxOwner2') }}</span>
                  <el-form-item :label="$t('SeaExport.SellerName')" class="lable-blue" style="width: 400px">
                    <cargo-rich-textarea
                      ref="sellerName"
                      v-model="form.sellerName"
                      :placeholder="$t('SeaExport.Name')"
                      no="sellerName"
                      :warning-count="warningCount"
                      :is-trim="true"
                      :disable-enter="true"
                      style="min-height: 28px;"
                      @dblclick.native="showNameAddressDialog($t('RailwayExport.BoxOwner2'), 'sellerName', 'sellerAddress')"
                    />
                  </el-form-item>
                  <el-form-item style="width: 400px">
                    <span slot="label" class="blue" v-html="$t('SeaExport.SellerAddress')" />
                    <cargo-rich-textarea
                      ref="sellerAddress"
                      v-model="form.sellerAddress"
                      no="sellerAddress"
                      :warning-count="warningCount"
                      :is-trim="true"
                      style="min-height: 70px;"
                      @dblclick.native="showNameAddressDialog($t('RailwayExport.BoxOwner2'), 'sellerName', 'sellerAddress')"
                    />
                  </el-form-item>
                  <el-form-item
                    v-if="form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_CARRIER.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_STRAIGHT_CARRIER.code"
                    :label="$t('SeaExport.EORICode')"
                    style="width: 400px"
                  >
                    <el-input ref="sellerIdNumber" v-model="form.sellerIdNumber" no="sellerIdNumber" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.SellerPostalCode')" style="width: 400px">
                    <el-input ref="sellerPostalCode" v-model="form.sellerPostalCode" no="sellerPostalCode" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.SellerCountry')" style="width: 400px">
                    <div style="display: flex">
                      <cargo-advance-select
                        ref="sellerCountry"
                        no="sellerCountry"
                        :select-type="TYPE_NAMES.basic_data_Country"
                        filterable
                        tag-name="code"
                        :show-custom-label-in-option="true"
                        :custom-label="p=>`${p.code}（${p.name}）`"
                        :default-value="form.sellerCountry"
                        @parentCallBack="p=>{form.sellerCountry=p.value}"
                      />
                      <span style="width: 170px;text-align: center;color: black;">{{ $t('SeaExport.SellerCity') }}</span>
                      <el-input ref="sellerCity" v-model="form.sellerCity" no="sellerCity" type="text" :filter-chars="false" />
                    </div>
                  </el-form-item>
                </template>
              </div>
            </el-form>
          </div>
        </div>
      </template>
      <template v-if="isHMM">
        <div class="custom-dialog-content" style="width: fit-content; display: flex">
          <div class="vertical-line" />
          <div class="form-section">
            <el-form label-width="120px" label-position="right">
              <div>
                <div style="height: 10px" />
                <el-form-item no="ENSDeclaration" :label="$t('SeaExport.EuroLineENSDeclaration')" style="width: 350px" class="lable-blue">
                  <el-select v-model="form.euEnsFilingTag" :label="$t('SeaExport.EuroLineENSDeclaration')" :placeholder="$t('SeaExport.SelectEuroLineENSDeclaration')">
                    <el-option
                      v-for="(item,index) in SeaExportConstants.ENS_DECLARATION"
                      :key="index"
                      :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item no="manifestType" :label="$t('SeaExport.ManifestType')" style="width: 350px" class="lable-blue">
                  <el-select v-model="form.manifestType" :label="$t('SeaExport.ManifestType')" :placeholder="$t('SeaExport.SelectManifestType')">
                    <el-option
                      v-for="(item,index) in SeaExportConstants.MANIFEST_TYPE"
                      :key="index"
                      :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item no="supplementaryDeclarant" :label="$t('SeaExport.SupplementaryDeclarant')" style="width: 350px">
                  <el-input v-model="form.supplementaryDeclarantEoriNo" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item no="chemicalType" :label="$t('SeaExport.ChemicalIdentifier')" style="width: 350px">
                  <el-select v-model="form.chemicalTag" no="chemicalTag">
                    <el-option :label="$t('SeaExport.ChemicalProduct')" :value="true" />
                    <el-option :label="$t('SeaExport.NonChemicalProduct')" :value="false" />
                  </el-select>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="vertical-line" />
          <div class="form-section">
            <el-form label-width="160px" label-position="right" style="width: 320px">
              <div>
                <span class="title">{{ $t('SeaExport.Shipper') }}</span>
                <el-button no="copyBusiness" type="primary" class="custom-button" @click="euBolCopyDialog.visible = true">{{ $t('SeaExport.CopyBusiness') }}</el-button>
                <el-form-item>
                  <span slot="label" class="blue" v-html="$t('SeaExport.PostalInformation2')" />
                  <el-input v-model="form.shipperPostalInfo" no="1" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ShipperStreetNumber')" class="lable-blue">
                  <el-input v-model="form.shipperStreetNo" no="2" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ShipperStreetName')" class="lable-blue">
                  <el-input v-model="form.shipperStreetName" no="3" type="text" :filter-chars="false" />
                </el-form-item>
                <el-tooltip class="item" :content="$t('SeaExport.EORICodeExample')">
                  <el-form-item :label="$t('SeaExport.EORICode')">
                    <el-input v-model="form.shipperIdNumber" :placeholder="$t('SystemMaintenance.Example') + ':EORI+CZ28937668'" no="4" type="text" :filter-chars="false" />
                  </el-form-item>
                </el-tooltip>
                <el-form-item :label="$t('SeaExport.ShipperZipCode')">
                  <el-input v-model="form.shipperPostalCode" no="5" type="text" :filter-chars="false" />
                </el-form-item>

                <span class="title">{{ $t('SeaExport.Consignee') }}</span>
                <el-form-item>
                  <span slot="label" class="blue" v-html="$t('SeaExport.PostalInformation2')" />
                  <el-input v-model="form.consigneePostalInfo" no="6" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ConsigneeStreetNumber')" class="lable-blue">
                  <el-input v-model="form.consigneeStreetNo" no="7" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ConsigneeStreetName')" class="lable-blue">
                  <el-input v-model="form.consigneeStreetName" no="8" type="text" :filter-chars="false" />
                </el-form-item>
                <el-tooltip class="item" :content="$t('SeaExport.EORICodeExample')">
                  <el-form-item :label="$t('SeaExport.EORICode')">
                    <el-input v-model="form.consigneeId" :placeholder="$t('SystemMaintenance.Example') + ':EORI+CZ28937668'" no="9" type="text" :filter-chars="false" />
                  </el-form-item>
                </el-tooltip>
                <el-form-item :label="$t('SeaExport.ConsigneeZipCode')">
                  <el-input v-model="form.consigneePostalCode" no="10" type="text" :filter-chars="false" />
                </el-form-item>

                <span class="title">{{ $t('SeaExport.NotifyParty') }}</span>
                <el-form-item>
                  <span slot="label" v-html="$t('SeaExport.PostalInformation2')" />
                  <el-input v-model="form.notifyPostalInfo" no="11" type="text" :placeholder="$t('SeaExport.TOOrderRequired')" :filter-chars="false" />
                </el-form-item>
                <el-tooltip class="item" :content="$t('SeaExport.TOOrderRequired')">
                  <el-form-item :label="$t('SeaExport.NotifyStreetNumber')">
                    <el-input v-model="form.notifyStreetNo" no="12" type="text" :placeholder="$t('SeaExport.TOOrderRequired')" :filter-chars="false" />
                  </el-form-item>
                </el-tooltip>
                <el-tooltip class="item" :content="$t('SeaExport.TOOrderRequired')">
                  <el-form-item :label="$t('SeaExport.NotifyStreetName')">
                    <el-input v-model="form.notifyStreetName" no="13" type="text" :placeholder="$t('SeaExport.TOOrderRequired')" :filter-chars="false" />
                  </el-form-item>
                </el-tooltip>
                <el-tooltip class="item" :content="$t('SeaExport.EORICodeExample')">
                  <el-form-item :label="$t('SeaExport.EORICode')">
                    <el-input v-model="form.notifyCodeForManifest" :placeholder="$t('SeaExport.TOOrderRequired')" no="14" type="text" :filter-chars="false" />
                  </el-form-item>
                </el-tooltip>
                <el-tooltip class="item" :content="$t('SeaExport.TOOrderRequired')">
                  <el-form-item :label="$t('SeaExport.notifyingPhone')">
                    <el-input v-model="form.notifyPhone" no="15" type="text" :placeholder="$t('SeaExport.TOOrderRequired')" :filter-chars="false" />
                  </el-form-item>
                </el-tooltip>
                <el-form-item :label="$t('SeaExport.NotifyZipCode')">
                  <el-input v-model="form.notifyPostalCode" no="16" type="text" :filter-chars="false" />
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="vertical-line" />
          <div v-if="form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_B.code" class="form-section">
            <el-form label-width="160px" label-position="right" style="width: 320px">
              <div>
                <span class="title">{{ $t('SeaExport.ActualShipper') }}</span>
                <el-button no="copyActualShipper" type="primary" class="custom-button" @click="copyShipperOrConsignee('shipper')">{{ $t('SeaExport.CopyActualShipper') }}</el-button>
                <el-form-item :label="$t('SeaExport.ShipperName')" class="lable-blue">
                  <cargo-rich-textarea
                    v-model="form.actualShipperName"
                    no="17"
                    :warning-count="warningCount"
                    :is-trim="true"
                    :disable-enter="true"
                    style="min-height: 28px;"
                    @dblclick.native="showNameAddressDialog($t('SeaExport.ActualShipper'), 'actualShipperName', 'actualShipperAddress')"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ShipperAddress')">
                  <cargo-rich-textarea
                    v-model="form.actualShipperAddress"
                    no="18"
                    :warning-count="warningCount"
                    :is-trim="true"
                    style="min-height: 70px;"
                    @dblclick.native="showNameAddressDialog($t('SeaExport.ActualShipper'), 'actualShipperName', 'actualShipperAddress')"
                  />
                </el-form-item>
                <el-form-item>
                  <span slot="label" class="blue" v-html="$t('SeaExport.PostalInformation2')" />
                  <el-input v-model="form.actualShipperPostalInfo" no="19" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ShipperStreetNumber')" class="lable-blue">
                  <el-input v-model="form.actualShipperStreetNo" no="20" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ShipperStreetName')" class="lable-blue">
                  <el-input v-model="form.actualShipperStreetName" no="21" type="text" :filter-chars="false" />
                </el-form-item>
                <el-tooltip class="item" :content="$t('SeaExport.EORICodeExample')">
                  <el-form-item :label="$t('SeaExport.EORICode')">
                    <el-input v-model="form.actualShipperCodeForManifest" :placeholder="$t('SystemMaintenance.Example') + ':EORI+CZ28937668'" no="22" type="text" :filter-chars="false" />
                  </el-form-item>
                </el-tooltip>
                <el-form-item :label="$t('SeaExport.ShipperZipCode')">
                  <el-input v-model="form.actualShipperPostalCode" no="23" type="text" :filter-chars="false" />
                </el-form-item>

                <span class="title">{{ $t('SeaExport.ActualConsignee') }}</span>
                <el-button no="copyBusiness" type="primary" class="custom-button" @click="copyShipperOrConsignee('consignee')">{{ $t('SeaExport.CopyActualConsignee') }}</el-button>
                <el-form-item :label="$t('SeaExport.ConsigneeName')" class="lable-blue">
                  <cargo-rich-textarea
                    v-model="form.actualConsigneeName"
                    no="24"
                    :warning-count="warningCount"
                    :is-trim="true"
                    :disable-enter="true"
                    style="min-height: 28px;"
                    @dblclick.native="showNameAddressDialog($t('SeaExport.ActualConsignee'), 'actualConsigneeName', 'actualConsigneeAddress')"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ConsigneeAddress')">
                  <cargo-rich-textarea
                    v-model="form.actualConsigneeAddress"
                    no="25"
                    :warning-count="warningCount"
                    :is-trim="true"
                    style="min-height: 70px;"
                    @dblclick.native="showNameAddressDialog($t('SeaExport.ActualConsignee'), 'actualConsigneeName', 'actualConsigneeAddress')"
                  />
                </el-form-item>
                <el-form-item>
                  <span slot="label" class="blue" v-html="$t('SeaExport.PostalInformation2')" />
                  <el-input v-model="form.actualConsigneePostalInfo" no="26" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ConsigneeStreetNumber')" class="lable-blue">
                  <el-input v-model="form.actualConsigneeStreetNo" no="27" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ConsigneeStreetName')" class="lable-blue">
                  <el-input v-model="form.actualConsigneeStreetName" no="28" type="text" :filter-chars="false" />
                </el-form-item>
                <el-tooltip class="item" :content="$t('SeaExport.EORICodeExample')">
                  <el-form-item :label="$t('SeaExport.EORICode')">
                    <el-input v-model="form.actualConsigneeIdNumber" :placeholder="$t('SystemMaintenance.Example') + ':EORI+CZ28937668'" no="29" type="text" :filter-chars="false" />
                  </el-form-item>
                </el-tooltip>
                <el-form-item :label="$t('SeaExport.ConsigneeZipCode')">
                  <el-input v-model="form.actualConsigneeCodeForManifest" no="30" type="text" :filter-chars="false" />
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </template>
      <template v-if="!isHPL && !isHMM">
        <el-button no="CopyBusinessSendConsigneeNotify" type="primary" style="margin: 10px 0 0 15px;" @click="euBolOtherCopyDialog.visible = true">{{ $t('SeaExport.CopyBusinessSendConsigneeNotify') }}</el-button>
        <div class="custom-dialog-content" style="width: fit-content; display: flex">
          <div class="vertical-line" />
          <div class="form-section">
            <el-form label-width="120px" label-position="right">
              <div>
                <span class="title">{{ $t('SeaExport.DeclarationInformation') }}</span>
                <el-form-item no="ENSDeclaration" :label="$t('SeaExport.EuroLineENSDeclaration')" style="width: 350px" class="lable-blue">
                  <el-select ref="euEnsFilingTag" v-model="form.euEnsFilingTag" :label="$t('SeaExport.EuroLineENSDeclaration')" placeholder=" " @change="onEuEnsFilingTagChange">
                    <el-option
                      v-for="(item,index) in SeaExportConstants.ENS_DECLARATION_HPL"
                      :key="index"
                      :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item no="supplementaryDeclarant" style="width: 350px">
                  <span
                    slot="label"
                    :class="form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_STRAIGHT_SUPPLEMENTARY.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_SELF.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_MIXED.code ? 'blue' : ''"
                  >
                    {{ $t('SeaExport.SupplementaryDeclarant') }}
                  </span>
                  <el-input ref="supplementaryDeclarantEoriNo" v-model="form.supplementaryDeclarantEoriNo" type="text" :filter-chars="false" @change="onOhterSupplementaryDeclarantChange" />
                </el-form-item>
                <el-form-item no="chemicalType" style="width: 350px">
                  <span slot="label" class="blue" v-html="$t('SeaExport.ChemicalIdentifier')" />
                  <el-select ref="chemicalTag" v-model="form.chemicalTag" no="chemicalTag">
                    <el-option :label="$t('SeaExport.ChemicalProduct')" :value="true" />
                    <el-option :label="$t('SeaExport.NonChemicalProduct')" :value="false" />
                  </el-select>
                </el-form-item>
                <el-form-item no="ucrNo" :label="$t('SeaExport.UCRNO')" style="width: 350px">
                  <el-input ref="ucrNo" v-model="form.ucrNo" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item no="factoryIdNumber" :label="$t('SeaExport.FactoryEORI')" style="width: 350px">
                  <el-input ref="factoryIdNumber" v-model="form.factoryIdNumber" :placeholder="$t('SeaExport.ExampleIllustrateEORI')" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item no="warehouseIdNumber" :label="$t('SeaExport.WarehouseEORI')" style="width: 350px">
                  <el-input ref="warehouseIdNumber" v-model="form.warehouseIdNumber" :placeholder="$t('SeaExport.ExampleIllustrateEORI')" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item no="lclPersonIdNumber" :label="$t('SeaExport.LCLPersonEORI')" style="width: 350px">
                  <el-input ref="lclPersonIdNumber" v-model="form.lclPersonIdNumber" :placeholder="$t('SeaExport.ExampleIllustrateEORI')" type="text" :filter-chars="false" />
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="vertical-line" />
          <div class="form-section">
            <el-form label-width="160px" label-position="right" style="width: 440px">
              <div>
                <span class="title">{{ $t('SeaExport.Shipper') }}</span>
                <el-form-item>
                  <span slot="label" v-html="$t('SeaExport.PostalInformation2')" />
                  <el-input ref="shipperPostalInfo" v-model="form.shipperPostalInfo" no="1" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ShipperStreetNumber')">
                  <el-input ref="shipperStreetNo" v-model="form.shipperStreetNo" no="2" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ShipperStreetName')">
                  <el-input ref="shipperStreetName" v-model="form.shipperStreetName" no="3" type="text" :filter-chars="false" />
                </el-form-item>
                <el-tooltip class="item">
                  <el-form-item :label="$t('SeaExport.EORICode')">
                    <el-input ref="shipperIdNumber" v-model="form.shipperIdNumber" no="4" type="text" :filter-chars="false" />
                  </el-form-item>
                </el-tooltip>
                <el-form-item :label="$t('SeaExport.ShipperZipCode')">
                  <el-input ref="shipperPostalCode" v-model="form.shipperPostalCode" no="5" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ActualShipperCountry')">
                  <div style="display: flex">
                    <cargo-advance-select
                      ref="shipperCountry"
                      no="shipperCountry"
                      :select-type="TYPE_NAMES.basic_data_Country"
                      filterable
                      tag-name="code"
                      :show-custom-label-in-option="true"
                      :custom-label="p=>`${p.code}（${p.name}）`"
                      :default-value="form.shipperCountry"
                      @parentCallBack="p=>{form.shipperCountry=p.value}"
                    />
                    <span style="width: 170px;text-align: center;color: black;">{{ $t('SeaExport.ActualShipperCity') }}</span>
                    <el-input ref="shipperCity" v-model="form.shipperCity" no="shipperCity" type="text" :filter-chars="false" />
                  </div>
                </el-form-item>
                <span class="title">{{ $t('SeaExport.Consignee') }}</span>
                <el-form-item>
                  <span slot="label" v-html="$t('SeaExport.PostalInformation2')" />
                  <el-input ref="consigneePostalInfo" v-model="form.consigneePostalInfo" no="6" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ConsigneeStreetNumber')">
                  <el-input ref="consigneeStreetNo" v-model="form.consigneeStreetNo" no="7" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ConsigneeStreetName')">
                  <el-input ref="consigneeStreetName" v-model="form.consigneeStreetName" no="8" type="text" :filter-chars="false" />
                </el-form-item>
                <el-tooltip class="item">
                  <el-form-item :label="$t('SeaExport.EORICode')">
                    <el-input ref="consigneeId" v-model="form.consigneeId" no="9" type="text" :filter-chars="false" />
                  </el-form-item>
                </el-tooltip>
                <el-form-item :label="$t('SeaExport.ConsigneeZipCode')">
                  <el-input ref="consigneePostalCode" v-model="form.consigneePostalCode" no="10" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.ActualRecipientCountry')">
                  <div style="display: flex">
                    <cargo-advance-select
                      ref="consigneeCountry"
                      no="consigneeCountry"
                      :select-type="TYPE_NAMES.basic_data_Country"
                      filterable
                      tag-name="code"
                      :show-custom-label-in-option="true"
                      :custom-label="p=>`${p.code}（${p.name}）`"
                      :default-value="form.consigneeCountry"
                      @parentCallBack="p=>{form.consigneeCountry=p.value}"
                    />
                    <span style="width: 170px;text-align: center;color: black;">{{ $t('SeaExport.ActualRecipientCity') }}</span>
                    <el-input ref="consigneeCity" v-model="form.consigneeCity" no="consigneeCity" type="text" :filter-chars="false" />
                  </div>
                </el-form-item>
                <span class="title">{{ $t('SeaExport.NotifyParty') }}</span>
                <el-form-item>
                  <span slot="label" v-html="$t('SeaExport.PostalInformation2')" />
                  <el-input ref="notifyPostalInfo" v-model="form.notifyPostalInfo" no="11" type="text" :filter-chars="false" />
                </el-form-item>
                <el-tooltip class="item">
                  <el-form-item :label="$t('SeaExport.NotifyStreetNumber')">
                    <el-input ref="notifyStreetNo" v-model="form.notifyStreetNo" no="12" type="text" :filter-chars="false" />
                  </el-form-item>
                </el-tooltip>
                <el-tooltip class="item">
                  <el-form-item :label="$t('SeaExport.NotifyStreetName')">
                    <el-input ref="notifyStreetName" v-model="form.notifyStreetName" no="13" type="text" :filter-chars="false" />
                  </el-form-item>
                </el-tooltip>
                <el-tooltip class="item">
                  <el-form-item :label="$t('SeaExport.EORICode')">
                    <el-input ref="notifyCodeForManifest" v-model="form.notifyCodeForManifest" no="14" type="text" :filter-chars="false" />
                  </el-form-item>
                </el-tooltip>
                <el-tooltip class="item">
                  <el-form-item :label="$t('SeaExport.NotifyPhone')">
                    <el-input ref="notifyPhone" v-model="form.notifyPhone" no="15" type="text" :filter-chars="false" />
                  </el-form-item>
                </el-tooltip>
                <el-form-item :label="$t('SeaExport.NotifyZipCode')">
                  <el-input ref="notifyPostalCode" v-model="form.notifyPostalCode" no="16" type="text" :filter-chars="false" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.NotificationCountry')">
                  <div style="display: flex">
                    <cargo-advance-select
                      ref="notifyCountry"
                      no="notifyCountry"
                      :select-type="TYPE_NAMES.basic_data_Country"
                      filterable
                      tag-name="code"
                      :show-custom-label-in-option="true"
                      :custom-label="p=>`${p.code}（${p.name}）`"
                      :default-value="form.notifyCountry"
                      @parentCallBack="p=>{form.notifyCountry=p.value}"
                    />
                    <span style="width: 170px;text-align: center;color: black;">{{ $t('SeaExport.NotifyPersonCity') }}</span>
                    <el-input ref="notifyCity" v-model="form.notifyCity" no="notifyCity" type="text" :filter-chars="false" />
                  </div>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <template v-if="form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_CARRIER.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_MIXED.code">
            <div class="vertical-line" />
            <div class="form-section">
              <el-form label-width="160px" label-position="right" style="width: 440px">
                <div>
                  <span class="title">{{ $t('SeaExport.ActualShipper') }}</span>
                  <el-button no="copyActualShipper" type="primary" class="custom-button" @click="copyActualShipperOther">{{ $t('SeaExport.CopyActualShipper') }}</el-button>
                  <el-form-item :label="$t('SeaExport.ShipperName')" class="lable-blue">
                    <cargo-rich-textarea
                      ref="actualShipperName"
                      v-model="form.actualShipperName"
                      :placeholder="$t('SeaExport.Name')"
                      no="17"
                      :warning-count="warningCount"
                      :is-trim="true"
                      :disable-enter="true"
                      style="min-height: 28px;"
                      @dblclick.native="showNameAddressDialog($t('SeaExport.ActualShipper'), 'actualShipperName', 'actualShipperAddress')"
                    />
                  </el-form-item>
                  <el-form-item>
                    <span slot="label" class="blue" v-html="$t('SeaExport.ShipperAddress')" />
                    <cargo-rich-textarea
                      ref="actualShipperAddress"
                      v-model="form.actualShipperAddress"
                      no="18"
                      :warning-count="warningCount"
                      :is-trim="true"
                      style="min-height: 70px;"
                      @dblclick.native="showNameAddressDialog($t('SeaExport.ActualShipper'), 'actualShipperName', 'actualShipperAddress')"
                    />
                  </el-form-item>
                  <el-form-item>
                    <span slot="label" v-html="$t('SeaExport.PostalInformation2')" />
                    <el-input ref="actualShipperPostalInfo" v-model="form.actualShipperPostalInfo" no="actualShipperPostalInfo" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.ShipperStreetNumber')">
                    <el-input ref="actualShipperStreetNo" v-model="form.actualShipperStreetNo" no="actualShipperStreetNo" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.ShipperStreetName')">
                    <el-input ref="actualShipperStreetName" v-model="form.actualShipperStreetName" no="actualShipperStreetName" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.EORICode')">
                    <el-input ref="actualShipperCodeForManifest" v-model="form.actualShipperCodeForManifest" :placeholder="$t('SeaExport.ExampleIllustrateEORI')" no="22" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.ShipperZipCode')">
                    <el-input ref="actualShipperPostalCode" v-model="form.actualShipperPostalCode" no="23" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.ActualShipperCountry')">
                    <div style="display: flex">
                      <cargo-advance-select
                        ref="actualShipperCountry"
                        no="actualShipperCountry"
                        :select-type="TYPE_NAMES.basic_data_Country"
                        filterable
                        tag-name="code"
                        :show-custom-label-in-option="true"
                        :custom-label="p=>`${p.code}（${p.name}）`"
                        :default-value="form.actualShipperCountry"
                        @parentCallBack="p=>{form.actualShipperCountry=p.value}"
                      />
                      <span style="width: 170px;text-align: center;color: black;">{{ $t('SeaExport.ActualShipperCity') }}</span>
                      <el-input ref="actualShipperCity" v-model="form.actualShipperCity" no="actualShipperCity" type="text" :filter-chars="false" />
                    </div>
                  </el-form-item>
                  <span class="title">{{ $t('SeaExport.ActualConsignee') }}</span>
                  <el-button no="copyBusiness" type="primary" class="custom-button" @click="copyActualConsigneeOther">{{ $t('SeaExport.CopyActualConsignee') }}</el-button>
                  <el-form-item :label="$t('SeaExport.ConsigneeName')" class="lable-blue">
                    <cargo-rich-textarea
                      ref="actualConsigneeName"
                      v-model="form.actualConsigneeName"
                      :placeholder="$t('SeaExport.Name')"
                      no="24"
                      :warning-count="warningCount"
                      :is-trim="true"
                      :disable-enter="true"
                      style="min-height: 28px;"
                      @dblclick.native="showNameAddressDialog($t('SeaExport.ActualConsignee'), 'actualConsigneeName', 'actualConsigneeAddress')"
                    />
                  </el-form-item>
                  <el-form-item>
                    <span slot="label" class="blue" v-html="$t('SeaExport.ConsigneeAddress')" />
                    <cargo-rich-textarea
                      ref="actualConsigneeAddress"
                      v-model="form.actualConsigneeAddress"
                      no="25"
                      :warning-count="warningCount"
                      :is-trim="true"
                      style="min-height: 70px;"
                      @dblclick.native="showNameAddressDialog($t('SeaExport.ActualConsignee'), 'actualConsigneeName', 'actualConsigneeAddress')"
                    />
                  </el-form-item>
                  <el-form-item>
                    <span slot="label" v-html="$t('SeaExport.PostalInformation2')" />
                    <el-input ref="actualConsigneePostalInfo" v-model="form.actualConsigneePostalInfo" no="actualConsigneePostalInfo" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.ConsigneeStreetNumber')">
                    <el-input ref="actualConsigneeStreetNo" v-model="form.actualConsigneeStreetNo" no="actualConsigneeStreetNo" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.ConsigneeStreetName')">
                    <el-input ref="actualConsigneeStreetName" v-model="form.actualConsigneeStreetName" no="actualConsigneeStreetName" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item
                    v-if="form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_CARRIER.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_MIXED.code"
                    :label="$t('SeaExport.EORICode')"
                  >
                    <el-input ref="actualConsigneeIdNumber" v-model="form.actualConsigneeIdNumber" :placeholder="$t('SeaExport.ExampleIllustrateEORI')" no="29" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.ConsigneeZipCode')">
                    <el-input ref="actualConsigneeCodeForManifest" v-model="form.actualConsigneeCodeForManifest" no="30" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.ActualRecipientCountry')">
                    <div style="display: flex">
                      <cargo-advance-select
                        ref="actualConsigneeCountry"
                        no="actualConsigneeCountry"
                        :select-type="TYPE_NAMES.basic_data_Country"
                        filterable
                        tag-name="code"
                        :show-custom-label-in-option="true"
                        :custom-label="p=>`${p.code}（${p.name}）`"
                        :default-value="form.actualConsigneeCountry"
                        @parentCallBack="p=>{form.actualConsigneeCountry=p.value}"
                      />
                      <span style="width: 170px;text-align: center;color: black;">{{ $t('SeaExport.ActualRecipientCity') }}</span>
                      <el-input ref="actualConsigneeCity" v-model="form.actualConsigneeCity" no="actualConsigneeCity" type="text" :filter-chars="false" />
                    </div>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </template>
          <template v-if="form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_CARRIER.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_STRAIGHT_CARRIER.code">
            <div class="vertical-line" />
            <div class="form-section">
              <el-form label-width="160px" label-position="right" style="width: 440px">
                <div>
                  <span class="title">{{ $t('SeaExport.Buyer') }}</span>
                  <el-button no="CopyActualRecipient" type="primary" class="custom-button" @click="copyActualRecipient">{{ $t('SeaExport.CopyActualRecipient') }}</el-button>
                  <el-form-item :label="$t('SeaExport.BuyerName')" class="lable-blue">
                    <cargo-rich-textarea
                      ref="buyerName"
                      v-model="form.buyerName"
                      no="buyerName"
                      :placeholder="$t('SeaExport.Name')"
                      :warning-count="warningCount"
                      :is-trim="true"
                      :disable-enter="true"
                      style="min-height: 28px;"
                      @dblclick.native="showNameAddressDialog($t('SeaExport.Buyer'), 'buyerName', 'buyerAddress')"
                    />
                  </el-form-item>
                  <el-form-item>
                    <span slot="label" class="blue" v-html="$t('SeaExport.BuyerAddress')" />
                    <cargo-rich-textarea
                      ref="buyerAddress"
                      v-model="form.buyerAddress"
                      no="buyerAddress"
                      :warning-count="warningCount"
                      :is-trim="true"
                      style="min-height: 70px;"
                      @dblclick.native="showNameAddressDialog($t('SeaExport.Buyer'), 'buyerName', 'buyerAddress')"
                    />
                  </el-form-item>
                  <el-form-item>
                    <span slot="label" v-html="$t('SeaExport.PostalInformation2')" />
                    <el-input ref="buyerPostalInfo" v-model="form.buyerPostalInfo" no="buyerPostalInfo" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.BuyerStreetNumber')">
                    <el-input ref="buyerStreetNo" v-model="form.buyerStreetNo" no="buyerStreetNo" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.BuyerStreetName')">
                    <el-input ref="buyerStreetName" v-model="form.buyerStreetName" no="buyerStreetName" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item
                    v-if="form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_CARRIER.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_STRAIGHT_CARRIER.code"
                    :label="$t('SeaExport.EORICode')"
                  >
                    <el-input ref="buyerIdNumber" v-model="form.buyerIdNumber" :placeholder="$t('SeaExport.ExampleIllustrateEORI')" no="buyerIdNumber" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.BuyerPostalCode')">
                    <el-input ref="buyerPostalCode" v-model="form.buyerPostalCode" no="buyerPostalCode" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.BuyerCountry')">
                    <div style="display: flex">
                      <cargo-advance-select
                        ref="buyerCountry"
                        no="buyerCountry"
                        :select-type="TYPE_NAMES.basic_data_Country"
                        filterable
                        tag-name="code"
                        :show-custom-label-in-option="true"
                        :custom-label="p=>`${p.code}（${p.name}）`"
                        :default-value="form.buyerCountry"
                        @parentCallBack="p=>{form.buyerCountry=p.value}"
                      />
                      <span style="width: 170px;text-align: center;color: black;">{{ $t('SeaExport.BuyerCity') }}</span>
                      <el-input ref="buyerCity" v-model="form.buyerCity" no="buyerCity" type="text" :filter-chars="false" />
                    </div>
                  </el-form-item>
                  <span class="title">{{ $t('RailwayExport.BoxOwner2') }}</span>
                  <el-button no="CopyActualShip" type="primary" class="custom-button" @click="copyActualShip">{{ $t('SeaExport.CopyActualShip') }}</el-button>
                  <el-form-item :label="$t('SeaExport.SellerName')" class="lable-blue">
                    <cargo-rich-textarea
                      ref="sellerName"
                      v-model="form.sellerName"
                      :placeholder="$t('SeaExport.Name')"
                      no="sellerName"
                      :warning-count="warningCount"
                      :is-trim="true"
                      :disable-enter="true"
                      style="min-height: 28px;"
                      @dblclick.native="showNameAddressDialog($t('RailwayExport.BoxOwner2'), 'sellerName', 'sellerAddress')"
                    />
                  </el-form-item>
                  <el-form-item>
                    <span slot="label" class="blue" v-html="$t('SeaExport.SellerAddress')" />
                    <cargo-rich-textarea
                      ref="sellerAddress"
                      v-model="form.sellerAddress"
                      no="sellerAddress"
                      :warning-count="warningCount"
                      :is-trim="true"
                      style="min-height: 70px;"
                      @dblclick.native="showNameAddressDialog($t('RailwayExport.BoxOwner2'), 'sellerName', 'sellerAddress')"
                    />
                  </el-form-item>
                  <el-form-item>
                    <span slot="label" v-html="$t('SeaExport.PostalInformation2')" />
                    <el-input ref="sellerPostalInfo" v-model="form.sellerPostalInfo" no="sellerPostalInfo" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.SellerStreetNumber')">
                    <el-input ref="sellerStreetNo" v-model="form.sellerStreetNo" no="sellerStreetNo" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.SellerStreetName')">
                    <el-input ref="sellerStreetName" v-model="form.sellerStreetName" no="sellerStreetName" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item
                    v-if="form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_CARRIER.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_STRAIGHT_CARRIER.code"
                    :label="$t('SeaExport.EORICode')"
                  >
                    <el-input ref="sellerIdNumber" v-model="form.sellerIdNumber" :placeholder="$t('SeaExport.ExampleIllustrateEORI')" no="sellerIdNumber" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.SellerPostalCode')">
                    <el-input ref="sellerPostalCode" v-model="form.sellerPostalCode" no="sellerPostalCode" type="text" :filter-chars="false" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.SellerCountry')">
                    <div style="display: flex">
                      <cargo-advance-select
                        ref="sellerCountry"
                        no="sellerCountry"
                        :select-type="TYPE_NAMES.basic_data_Country"
                        filterable
                        tag-name="code"
                        :show-custom-label-in-option="true"
                        :custom-label="p=>`${p.code}（${p.name}）`"
                        :default-value="form.sellerCountry"
                        @parentCallBack="p=>{form.sellerCountry=p.value}"
                      />
                      <span style="width: 170px;text-align: center;color: black;">{{ $t('SeaExport.SellerCity') }}</span>
                      <el-input ref="sellerCity" v-model="form.sellerCity" no="sellerCity" type="text" :filter-chars="false" />
                    </div>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </template>
        </div>
      </template>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="innerVisible = false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 抄录业务HPL -->
    <cargo-doc-extend-hpl-copy-dialog
      :visible.sync="euBolHplCopyDialog.visible"
      @selected="selectHplInfo"
    />
    <!-- 抄录业务HMM -->
    <cargo-doc-extend-copy-dialog
      :visible.sync="euBolCopyDialog.visible"
      @selected="selectInfo"
    />
    <!-- 抄录业务（其它） -->
    <cargo-doc-extend-other-copy-dialog
      :visible.sync="euBolOtherCopyDialog.visible"
      @selected="selectOtherInfo"
    />
    <!-- 名称、地址文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="nameAddressDialog.visible"
      :title="nameAddressDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        v-model="nameAddressDialog.value"
        :warning-count="warningCount"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button type="primary" @click="finishNameAddress">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="nameAddressDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import { copyShipperOrConsignee, getCargoDocExtend, saveCargoDocExtend } from '@/api/seaExport/seaCargoDoc'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import CargoDocExtendCopyDialog from '@/views/cargo/v0/SeaExport/components/edi/cargoDocExtendCopyDialog.vue'
import CargoDocExtendHplCopyDialog from '@/views/cargo/v0/SeaExport/components/edi/cargoDocExtendHplCopyDialog.vue'
import cargoDocExtendOtherCopyDialog from '@/views/cargo/v0/SeaExport/components/edi/cargoDocExtendOtherCopyDialog.vue'
import { poItems } from '@/api/seaExport/poItems'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { getSeaMblByJobUuid } from '@/api/seaExport/seaCargoDoc'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { cache } from '@/utils/cacheManager'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'

export default {
  name: 'CargoDocExtend',
  components: {
    CargoDocExtendCopyDialog, CargoDocExtendHplCopyDialog, cargoDocExtendOtherCopyDialog, cargoAdvanceSelect, cargoRichTextarea
  },
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, required: true, default: '' },
    jobUuid: { type: String, required: true, default: '' },
    seaCargoDoc: { type: Object, default: null },
    carrierId: { type: Number, default: 0 }
  },
  data() {
    return {
      SeaExportConstants,
      TYPE_NAMES,
      innerVisible: false,
      // 抄录业务
      euBolCopyDialog: {
        visible: false
      },
      // 抄录业务HPL
      euBolHplCopyDialog: {
        visible: false
      },
      euBolOtherCopyDialog: {
        visible: false
      },
      form: {
        jobUuid: '',
        euEnsFilingTag: '',
        manifestType: '',
        supplementaryDeclarantEoriNo: '',
        chemicalTag: false,
        shipperPostalInfo: '',
        shipperStreetNo: '',
        shipperStreetName: '',
        shipperIdNumber: '',
        shipperPostalCode: '',
        shipperCountry: '', // 发货人国家
        shipperCity: '', // 发货人城市
        consigneePostalInfo: '',
        consigneeStreetNo: '',
        consigneeStreetName: '',
        consigneeId: '',
        consigneePostalCode: '',
        consigneeCountry: '', // 收货人国家
        consigneeCity: '', // 收货人城市
        notifyPostalInfo: '',
        notifyStreetNo: '',
        notifyStreetName: '',
        notifyCodeForManifest: '',
        notifyPhone: '',
        notifyPostalCode: '',
        notifyCountry: '', // 通知人国家
        notifyCity: '', // 通知人城市
        actualShipperName: '',
        actualShipperAddress: '',
        actualShipperPostalInfo: '',
        actualShipperStreetNo: '',
        actualShipperStreetName: '',
        actualShipperCodeForManifest: '',
        actualShipperPostalCode: '',
        actualShipperCountry: '', // 实际发货人国家
        actualShipperCity: '', // 实际发货人城市
        actualConsigneeName: '',
        actualConsigneeAddress: '',
        actualConsigneePostalInfo: '',
        actualConsigneeStreetNo: '',
        actualConsigneeStreetName: '',
        actualConsigneeIdNumber: '',
        actualConsigneeCodeForManifest: '',
        actualConsigneeCountry: '', // 实际收货人国家
        actualConsigneeCity: '', // 实际收货人城市
        docType: 'MBL',
        buyerName: '', // 买方名称
        buyerAddress: '', // 买方地址
        buyerPostalInfo: '', // 买方邮政信息
        buyerStreetNo: '', // 买方街道号码
        buyerStreetName: '', // 买方街道名称
        buyerIdNumber: '', // 买方EORI代码
        buyerPostalCode: '', // 买方邮编
        buyerCountry: '', // 买方国家
        buyerCity: '', // 买方城市
        sellerName: '', // 卖方名称
        sellerAddress: '', // 卖方地址
        sellerPostalInfo: '', // 卖方邮政信息
        sellerStreetNo: '', // 卖方街道号码
        sellerStreetName: '', // 卖方街道名称
        sellerIdNumber: '', // 卖方EORI代码
        sellerPostalCode: '', // 卖方邮编
        sellerCountry: '', // 卖方国家
        sellerCity: '', // 卖方城市
        ucrNo: '', // UCR NO
        factoryIdNumber: '', // 工厂EORI
        warehouseIdNumber: '', // 仓库EORI
        lclPersonIdNumber: '' // 拼箱人EORI
      },
      isHPL: false,
      isHMM: false,
      warningCount: 45,
      nameAddressDialog: {
        visible: false,
        title: '',
        nameKey: '',
        addressKey: '',
        value: ''
      }
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
      if (this.innerVisible) {
        this.load()
      }
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async load() {
      this.warningCount = Number(cache.config.get('SEShipperConsigneNotifyWarningColor'))
      this.loading = getLoading()
      this.clearForm()
      const company = this.carrierId > 0 ? getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', this.carrierId) : null
      this.isHPL = company && (company.cnShortName === 'HPL' || company.shortName === 'HPL' || company.chineseName === 'HPL' || company.englishName === 'HPL')
      this.isHMM = !this.isHPL && company && (company.cnShortName === 'HMM' || company.shortName === 'HMM' || company.chineseName === 'HMM' || company.englishName === 'HMM')
      if (this.isHPL) {
        this.form.supplementaryDeclarantEoriNo = LocalStorageUtilsNew.getConfiguration('cargoDocExtend_hpl_supplementaryDeclarantEoriNo') || ''
        this.form.shipperIdNumber = 'EORI'
        this.form.consigneeId = 'EORI'
        this.form.notifyCodeForManifest = 'EORI'
        this.form.factoryIdNumber = 'EORI'
        this.form.warehouseIdNumber = 'EORI'
        this.form.lclPersonIdNumber = 'EORI'
        this.form.actualShipperCodeForManifest = 'EORI'
        this.form.actualConsigneeIdNumber = 'EORI'
        this.form.buyerIdNumber = 'EORI'
        this.form.sellerIdNumber = 'EORI'
      }
      if (!this.isHPL && !this.isHMM) {
        this.form.supplementaryDeclarantEoriNo = LocalStorageUtilsNew.getConfiguration('cargoDocExtend_other_supplementaryDeclarantEoriNo') || ''
        this.form.shipperIdNumber = 'EORI'
        this.form.consigneeId = 'EORI'
        this.form.notifyCodeForManifest = 'EORI'
        this.form.factoryIdNumber = 'EORI'
        this.form.warehouseIdNumber = 'EORI'
        this.form.lclPersonIdNumber = 'EORI'
        this.form.actualShipperCodeForManifest = 'EORI'
        this.form.actualConsigneeIdNumber = 'EORI'
        this.form.buyerIdNumber = 'EORI'
        this.form.sellerIdNumber = 'EORI'
      }
      // 收货人、发货人街道名称带出提单页签内容
      if (this.seaCargoDoc) {
        this.form.shipperStreetName = this.seaCargoDoc.shipperLine2
        this.form.consigneeStreetName = this.seaCargoDoc.consigneeLine2
        this.form.docType = this.seaCargoDoc.docType
      }
      try {
        const [poItemsRes, mblRes, cargoDocExtendRes] = await Promise.all([
          poItems({ jobUuid: this.jobUuid }),
          getSeaMblByJobUuid({ jobUuid: this.jobUuid }),
          getCargoDocExtend({ jobUuid: this.jobUuid, docType: this.form.docType })
        ])
        if (this.isHPL) {
          // 处理 poItems 的返回结果
          if (poItemsRes.data) {
            for (const element of poItemsRes.data) {
              if (element.cusCode) {
                this.form.chemicalTag = true
                break
              }
            }
          }
          // 处理 poItems 的返回结果
          if (mblRes.data) {
            if (mblRes.data.cusCode) {
              this.form.chemicalTag = true
            }
          }
          // 处理 getCargoDocExtend 的返回结果
          if (cargoDocExtendRes.data) {
            this.form = cargoDocExtendRes.data
            if (cargoDocExtendRes.data.cusCode) {
              return
            }
          }
        } else if (this.isHMM) {
          // 处理 getCargoDocExtend 的返回结果
          if (cargoDocExtendRes.data) {
            this.form = cargoDocExtendRes.data
            if (cargoDocExtendRes.data.cusCode) {
              return
            }
          }
          // 处理 poItems 的返回结果
          if (poItemsRes.data) {
            for (const element of poItemsRes.data) {
              if (element.cusCode) {
                this.form.chemicalTag = true
                break
              }
            }
          }
        } else {
          // 处理 poItems 的返回结果
          if (poItemsRes.data) {
            for (const element of poItemsRes.data) {
              if (element.cusCode) {
                this.form.chemicalTag = true
                break
              }
            }
          }
          // 处理 poItems 的返回结果
          if (mblRes.data) {
            if (mblRes.data.cusCode) {
              this.form.chemicalTag = true
            }
          }
          // 处理 getCargoDocExtend 的返回结果
          if (cargoDocExtendRes.data) {
            this.form = cargoDocExtendRes.data
            if (cargoDocExtendRes.data.cusCode) {
              return
            }
          }
        }
      } catch (error) {
        this.$message.error(error)
      } finally {
        this.loading.close()
      }
    },
    async save() {
      this.loading = getLoading()
      try {
        if (this.isHPL) {
          if (!this.checkHplForm()) return
        } else if (this.isHMM) {
          if (!this.checkForm()) return
        } else {
          if (!this.checkHplForm()) return
        }
        if (this.seaCargoDoc?.docType) {
          this.form.docType = this.seaCargoDoc.docType
        }
        if (this.form.notifyStreetName === 'Same as consignee') {
          this.form.notifyStreetName = this.form.consigneeStreetName
        }
        this.form.jobUuid = this.jobUuid
        await saveCargoDocExtend(this.form)
        this.innerVisible = false
        this.$message.success(this.$t('SeaExport.SavedSuccessfully'))
      } catch (error) {
        this.$message.error(error)
      } finally {
        this.loading.close()
      }
    },
    clearForm() {
      this.form = {
        jobUuid: '',
        euEnsFilingTag: '',
        manifestType: '',
        supplementaryDeclarantEoriNo: '',
        chemicalTag: false,
        shipperPostalInfo: '',
        shipperStreetNo: '',
        shipperStreetName: '',
        shipperIdNumber: '',
        shipperPostalCode: '',
        shipperCountry: '', // 发货人国家
        shipperCity: '', // 发货人城市
        consigneePostalInfo: '',
        consigneeStreetNo: '',
        consigneeStreetName: '',
        consigneeId: '',
        consigneePostalCode: '',
        consigneeCountry: '', // 收货人国家
        consigneeCity: '', // 收货人城市
        notifyPostalInfo: '',
        notifyStreetNo: '',
        notifyStreetName: '',
        notifyCodeForManifest: '',
        notifyPhone: '',
        notifyPostalCode: '',
        notifyCountry: '', // 通知人国家
        notifyCity: '', // 通知人城市
        actualShipperName: '',
        actualShipperAddress: '',
        actualShipperPostalInfo: '',
        actualShipperStreetNo: '',
        actualShipperStreetName: '',
        actualShipperCodeForManifest: '',
        actualShipperPostalCode: '',
        actualShipperCountry: '', // 实际发货人国家
        actualShipperCity: '', // 实际发货人城市
        actualConsigneeName: '',
        actualConsigneeAddress: '',
        actualConsigneePostalInfo: '',
        actualConsigneeStreetNo: '',
        actualConsigneeStreetName: '',
        actualConsigneeIdNumber: '',
        actualConsigneeCodeForManifest: '',
        actualConsigneeCountry: '', // 实际收货人国家
        actualConsigneeCity: '', // 实际收货人城市
        docType: 'MBL',
        buyerName: '', // 买方名称
        buyerAddress: '', // 买方地址
        buyerPostalInfo: '', // 买方邮政信息
        buyerStreetNo: '', // 买方街道号码
        buyerStreetName: '', // 买方街道名称
        buyerIdNumber: '', // 买方EORI代码
        buyerPostalCode: '', // 买方邮编
        buyerCountry: '', // 买方国家
        buyerCity: '', // 买方城市
        sellerName: '', // 卖方名称
        sellerAddress: '', // 卖方地址
        sellerPostalInfo: '', // 卖方邮政信息
        sellerStreetNo: '', // 卖方街道号码
        sellerStreetName: '', // 卖方街道名称
        sellerIdNumber: '', // 卖方EORI代码
        sellerPostalCode: '', // 卖方邮编
        sellerCountry: '', // 卖方国家
        sellerCity: '', // 卖方城市
        ucrNo: '', // UCR NO
        factoryIdNumber: '', // 工厂EORI
        warehouseIdNumber: '', // 仓库EORI
        lclPersonIdNumber: '' // 拼箱人EORI
      }
    },
    checkHplForm() {
      const form = this.form
      for (const key in form) {
        if (typeof form[key] === 'string') {
          form[key] = form[key].trim()
        }
      }
      const msgs = []
      if (!this.form.euEnsFilingTag) {
        msgs.push(this.$t('SeaExport.SelectEuroLineENSDeclaration'))
      }
      if (form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_STRAIGHT_SUPPLEMENTARY.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_SELF.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_MIXED.code) {
        if (!form.supplementaryDeclarantEoriNo) {
          msgs.push(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.SupplementaryDeclarant')]))
        }
      }
      if (form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_CARRIER.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_MIXED.code) {
        if (!form.actualShipperName) {
          msgs.push(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.ShipperName')]))
        }
        if (!form.actualShipperAddress) {
          msgs.push(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.ShipperAddress')]))
        }
        if (!form.actualConsigneeName) {
          msgs.push(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.ConsigneeName')]))
        }
        if (!form.actualConsigneeAddress) {
          msgs.push(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.ConsigneeAddress')]))
        }
      }
      if (form.euEnsFilingTag !== SeaExportConstants.ENS_DECLARATION_HOUSE_MIXED.code) {
        if (form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_CARRIER.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_HOUSE_MIXED.code || form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_STRAIGHT_CARRIER.code) {
          if (!form.buyerName) {
            msgs.push(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.BuyerName')]))
          }
          if (!form.buyerAddress) {
            msgs.push(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.BuyerAddress')]))
          }
          if (!form.sellerName) {
            msgs.push(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.SellerName')]))
          }
          if (!form.sellerAddress) {
            msgs.push(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.SellerAddress')]))
          }
        }
      }
      if (msgs.length > 0) {
        this.$message.warning({ dangerouslyUseHTMLString: true, message: msgs.join('<br>') })
        return false
      }
      return true
    },
    checkForm() {
      for (const key in this.form) {
        if (typeof this.form[key] === 'string') {
          this.form[key] = this.form[key].trim()
        }
      }
      if (!this.form.euEnsFilingTag) {
        this.$message.warning(this.$t('SeaExport.SelectEuroLineENSDeclaration'))
        return false
      }
      if (!this.form.manifestType) {
        this.$message.warning(this.$t('SeaExport.SelectManifestType'))
        return false
      }
      if (!this.form.shipperPostalInfo && !this.form.shipperStreetNo && !this.form.shipperStreetName) {
        this.$message.warning(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.Shipper')]) + this.$t('SeaExport.StreetInfo'))
        return false
      }
      if (!this.form.consigneePostalInfo && !this.form.consigneeStreetNo && !this.form.consigneeStreetName) {
        this.$message.warning(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.Consignee')]) + this.$t('SeaExport.StreetInfo'))
        return false
      }
      if (this.form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_B.code && !this.form.actualConsigneePostalInfo &&
        !this.form.actualConsigneeStreetNo && !this.form.actualConsigneeStreetName) {
        this.$message.warning(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.ActualConsignee')]) + this.$t('SeaExport.StreetInfo'))
        return false
      }
      if (this.form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_B.code && !this.form.actualShipperPostalInfo &&
        !this.form.actualShipperStreetNo && !this.form.actualShipperStreetName) {
        this.$message.warning(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.ActualShipper')]) + this.$t('SeaExport.StreetInfo'))
        return false
      }
      if (this.form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_B.code && !this.form.actualConsigneePostalInfo &&
        !this.form.actualConsigneeStreetNo && !this.form.actualConsigneeStreetName) {
        this.$message.warning(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.ActualConsignee')]) + this.$t('SeaExport.StreetInfo'))
        return false
      }
      if (!this.form.shipperPostalInfo && (!this.form.shipperStreetNo || !this.form.shipperStreetName)) {
        if (!this.form.shipperStreetNo) {
          this.$message.warning(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.ShipperStreetNumber')]))
          return false
        }
        if (!this.form.shipperStreetName) {
          this.$message.warning(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.ShipperStreetName')]))
          return false
        }
      }
      if (!this.form.consigneePostalInfo && (!this.form.consigneeStreetNo || !this.form.consigneeStreetName)) {
        if (!this.form.consigneeStreetNo) {
          this.$message.warning(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.ConsigneeStreetNumber')]))
          return false
        }
        if (!this.form.consigneeStreetName) {
          this.$message.warning(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.ConsigneeStreetName')]))
          return false
        }
      }
      if (this.form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_B.code && !this.form.actualShipperPostalInfo && (!this.form.actualShipperStreetNo || !this.form.actualShipperStreetName)) {
        if (!this.form.actualShipperStreetNo) {
          this.$message.warning(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.ActualShipperStreetNumber')]))
          return false
        }
        if (!this.form.actualShipperStreetName) {
          this.$message.warning(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.ActualShipperStreetName')]))
          return false
        }
      }
      if (this.form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_B.code && !this.form.actualConsigneePostalInfo && (!this.form.actualConsigneeStreetNo || !this.form.actualConsigneeStreetName)) {
        if (!this.form.actualConsigneeStreetNo) {
          this.$message.warning(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.ActualConsigneeStreetNumber')]))
          return false
        }
        if (!this.form.actualConsigneeStreetName) {
          this.$message.warning(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.ActualConsigneeStreetName')]))
          return false
        }
      }
      if (this.form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_B.code && !this.form.actualShipperName) {
        this.$message.warning(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.ActualShipperName')]))
        return false
      }
      if (this.form.euEnsFilingTag === SeaExportConstants.ENS_DECLARATION_B.code && !this.form.actualConsigneeName) {
        this.$message.warning(this.$t('SeaExport.PlsInputParameter', [this.$t('SeaExport.ActualConsigneeName')]))
        return false
      }

      return true
    },
    async copyShipperOrConsignee(type) {
      this.loading = getLoading()
      if (this.seaCargoDoc) {
        if (this.seaCargoDoc.docType === 'MBL') {
          if (type === 'shipper') {
            this.form.actualShipperName = this.seaCargoDoc.shipperLine1
            this.form.actualShipperAddress = this.seaCargoDoc.shipperLine2 + this.seaCargoDoc.shipperLine3
          }
          if (type === 'consignee') {
            this.form.actualConsigneeName = this.seaCargoDoc.consigneeLine1
            this.form.actualConsigneeAddress = this.seaCargoDoc.consigneeLine2 + this.seaCargoDoc.consigneeLine3
          }
        }
        this.loading.close()
      } else {
        await copyShipperOrConsignee({ 'jobUuid': this.jobUuid, 'type': type }).then(res => {
          if (res.data) {
            if (type === 'shipper') {
              this.form.actualShipperName = res.data.actualShipperName
              this.form.actualShipperAddress = res.data.actualShipperAddress
            }
            if (type === 'consignee') {
              this.form.actualConsigneeName = res.data.actualConsigneeName
              this.form.actualConsigneeAddress = res.data.actualConsigneeAddress
            }
          }
        }).catch(error => this.$message.error(error)).finally(() => this.loading.close())
      }
    },
    selectHplInfo(data) {
      this.form.actualShipperName = data.actualShipperName
      this.form.actualShipperAddress = data.actualShipperAddress
      this.form.actualShipperCountry = data.actualShipperCountry
      this.form.actualShipperCity = data.actualShipperCity
      this.form.actualShipperPostalCode = data.actualShipperPostalCode
      this.form.actualShipperCodeForManifest = data.actualShipperCodeForManifest
      this.form.actualConsigneeName = data.actualConsigneeName
      this.form.actualConsigneeAddress = data.actualConsigneeAddress
      this.form.actualConsigneeCountry = data.actualConsigneeCountry
      this.form.actualConsigneeCity = data.actualConsigneeCity
      this.form.actualConsigneeCodeForManifest = data.actualConsigneeCodeForManifest
      this.form.actualConsigneeIdNumber = data.actualConsigneeIdNumber
      this.form.buyerName = data.buyerName
      this.form.buyerAddress = data.buyerAddress
      this.form.buyerCountry = data.buyerCountry
      this.form.buyerCity = data.buyerCity
      this.form.buyerPostalCode = data.buyerPostalCode
      this.form.buyerIdNumber = data.buyerIdNumber
      this.form.sellerName = data.sellerName
      this.form.sellerAddress = data.sellerAddress
      this.form.sellerCountry = data.sellerCountry
      this.form.sellerCity = data.sellerCity
      this.form.sellerPostalCode = data.sellerPostalCode
      this.form.sellerIdNumber = data.sellerIdNumber
    },
    selectOtherInfo(data) {
      this.form.shipperPostalInfo = data.shipperPostalInfo
      this.form.shipperStreetNo = data.shipperStreetNo
      this.form.shipperStreetName = data.shipperStreetName
      this.form.shipperIdNumber = data.shipperIdNumber
      this.form.shipperPostalCode = data.shipperPostalCode
      this.form.shipperCountry = data.shipperCountry
      this.form.shipperCity = data.shipperCity
      this.form.consigneePostalInfo = data.consigneePostalInfo
      this.form.consigneeStreetNo = data.consigneeStreetNo
      this.form.consigneeStreetName = data.consigneeStreetName
      this.form.consigneeId = data.consigneeId
      this.form.consigneePostalCode = data.consigneePostalCode
      this.form.consigneeCountry = data.consigneeCountry
      this.form.consigneeCity = data.consigneeCity
      this.form.notifyPostalInfo = data.notifyPostalInfo
      this.form.notifyStreetNo = data.notifyStreetNo
      this.form.notifyStreetName = data.notifyStreetName
      this.form.notifyCodeForManifest = data.notifyCodeForManifest
      this.form.notifyPhone = data.notifyPhone
      this.form.notifyPostalCode = data.notifyPostalCode
      this.form.notifyCountry = data.notifyCountry
      this.form.notifyCity = data.notifyCity
      this.form.actualShipperName = data.actualShipperName
      this.form.actualShipperAddress = data.actualShipperAddress
      this.form.actualShipperPostalInfo = data.actualShipperPostalInfo
      this.form.actualShipperStreetNo = data.actualShipperStreetNo
      this.form.actualShipperStreetName = data.actualShipperStreetName
      this.form.actualShipperCodeForManifest = data.actualShipperCodeForManifest
      this.form.actualShipperPostalCode = data.actualShipperPostalCode
      this.form.actualShipperCountry = data.actualShipperCountry
      this.form.actualShipperCity = data.actualShipperCity
      this.form.actualConsigneeName = data.actualConsigneeName
      this.form.actualConsigneeAddress = data.actualConsigneeAddress
      this.form.actualConsigneePostalInfo = data.actualConsigneePostalInfo
      this.form.actualConsigneeStreetNo = data.actualConsigneeStreetNo
      this.form.actualConsigneeStreetName = data.actualConsigneeStreetName
      this.form.actualConsigneeIdNumber = data.actualConsigneeIdNumber
      this.form.actualConsigneeCodeForManifest = data.actualConsigneeCodeForManifest
      this.form.actualConsigneeCountry = data.actualConsigneeCountry
      this.form.actualConsigneeCity = data.actualConsigneeCity
      this.form.buyerName = data.buyerName
      this.form.buyerAddress = data.buyerAddress
      this.form.buyerPostalInfo = data.buyerPostalInfo
      this.form.buyerStreetNo = data.buyerStreetNo
      this.form.buyerStreetName = data.buyerStreetName
      this.form.buyerIdNumber = data.buyerIdNumber
      this.form.buyerPostalCode = data.buyerPostalCode
      this.form.buyerCountry = data.buyerCountry
      this.form.buyerCity = data.buyerCity
      this.form.sellerName = data.sellerName
      this.form.sellerAddress = data.sellerAddress
      this.form.sellerPostalInfo = data.sellerPostalInfo
      this.form.sellerStreetNo = data.sellerStreetNo
      this.form.sellerStreetName = data.sellerStreetName
      this.form.sellerIdNumber = data.sellerIdNumber
      this.form.sellerPostalCode = data.sellerPostalCode
      this.form.sellerCountry = data.sellerCountry
      this.form.sellerCity = data.sellerCity
    },
    selectInfo(data) {
      for (const key in data) {
        if (key === 'jobUuid' || key === 'euEnsFilingTag' || key === 'manifestType' || key === 'supplementaryDeclarantEoriNo' || key === 'chemicalTag') {
          continue
        }
        // 如果源对象中有相同的属性，就复制过来
        if (this.form.hasOwnProperty(key)) {
          this.form[key] = data[key]
        }
      }
    },
    async copyActualShipper() {
      let cargoDoc = this.seaCargoDoc
      if (!(cargoDoc && cargoDoc.docType === 'MBL')) {
        const loading = getLoading4Cxt(this)
        try {
          cargoDoc = await getSeaMblByJobUuid({ 'jobUuid': this.jobUuid }).then(res => res.data)
        } finally {
          loading.close()
        }
      }
      if (cargoDoc) {
        this.form.actualShipperName = cargoDoc.shipperLine1
        let address = ''
        for (let i = 2; i <= 7; ++i) {
          if (address) {
            address += '\n'
          }
          address += cargoDoc['shipperLine' + i]
        }
        this.form.actualShipperAddress = address
        this.form.actualShipperCodeForManifest = this.form.shipperIdNumber
      }
    },
    async copyActualConsignee() {
      let cargoDoc = this.seaCargoDoc
      if (!(cargoDoc && cargoDoc.docType === 'MBL')) {
        const loading = getLoading4Cxt(this)
        try {
          cargoDoc = await getSeaMblByJobUuid({ 'jobUuid': this.jobUuid }).then(res => res.data)
        } finally {
          loading.close()
        }
      }
      if (cargoDoc) {
        this.form.actualConsigneeName = cargoDoc.consigneeLine1
        let address = ''
        for (let i = 2; i <= 7; ++i) {
          if (address) {
            address += '\n'
          }
          address += cargoDoc['consigneeLine' + i]
        }
        this.form.actualConsigneeAddress = address
        this.form.actualConsigneeIdNumber = this.form.consigneeId
      }
    },
    onSupplementaryDeclarantChange() {
      LocalStorageUtilsNew.setConfiguration('cargoDocExtend_hpl_supplementaryDeclarantEoriNo', this.form.supplementaryDeclarantEoriNo)
    },
    onOhterSupplementaryDeclarantChange() {
      LocalStorageUtilsNew.setConfiguration('cargoDocExtend_other_supplementaryDeclarantEoriNo', this.form.supplementaryDeclarantEoriNo)
    },
    onEuEnsFilingTagChange() {
      if (this.form.uuid) {
        return
      }
      const defaultForm = {
        supplementaryDeclarantEoriNo: '',
        shipperPostalInfo: '',
        shipperStreetNo: '',
        shipperStreetName: '',
        shipperIdNumber: '',
        shipperPostalCode: '',
        shipperCountry: '', // 发货人国家
        shipperCity: '', // 发货人城市
        consigneePostalInfo: '',
        consigneeStreetNo: '',
        consigneeStreetName: '',
        consigneeId: '',
        consigneePostalCode: '',
        consigneeCountry: '', // 收货人国家
        consigneeCity: '', // 收货人城市
        notifyPostalInfo: '',
        notifyStreetNo: '',
        notifyStreetName: '',
        notifyCodeForManifest: '',
        notifyPhone: '',
        notifyPostalCode: '',
        notifyCountry: '', // 通知人国家
        notifyCity: '', // 通知人城市
        actualShipperName: '',
        actualShipperAddress: '',
        actualShipperPostalInfo: '',
        actualShipperStreetNo: '',
        actualShipperStreetName: '',
        actualShipperCodeForManifest: '',
        actualShipperPostalCode: '',
        actualShipperCountry: '', // 实际发货人国家
        actualShipperCity: '', // 实际发货人城市
        actualConsigneeName: '',
        actualConsigneeAddress: '',
        actualConsigneePostalInfo: '',
        actualConsigneeStreetNo: '',
        actualConsigneeStreetName: '',
        actualConsigneeIdNumber: '',
        actualConsigneeCodeForManifest: '',
        actualConsigneeCountry: '', // 实际收货人国家
        actualConsigneeCity: '', // 实际收货人城市
        buyerName: '', // 买方名称
        buyerAddress: '', // 买方地址
        buyerPostalInfo: '', // 买方邮政信息
        buyerStreetNo: '', // 买方街道号码
        buyerStreetName: '', // 买方街道名称
        buyerIdNumber: '', // 买方EORI代码
        buyerPostalCode: '', // 买方邮编
        buyerCountry: '', // 买方国家
        buyerCity: '', // 买方城市
        sellerName: '', // 卖方名称
        sellerAddress: '', // 卖方地址
        sellerPostalInfo: '', // 卖方邮政信息
        sellerStreetNo: '', // 卖方街道号码
        sellerStreetName: '', // 卖方街道名称
        sellerIdNumber: '', // 卖方EORI代码
        sellerPostalCode: '', // 卖方邮编
        sellerCountry: '', // 卖方国家
        sellerCity: '', // 卖方城市
        ucrNo: '', // UCR NO
        factoryIdNumber: '', // 工厂EORI
        warehouseIdNumber: '', // 仓库EORI
        lclPersonIdNumber: '' // 拼箱人EORI
      }
      this.$nextTick(() => {
        for (const key in defaultForm) {
          if (!this.$refs[key]) {
            this.form[key] = defaultForm[key]
          }
        }
      })
    },
    async copyActualShipperOther() {
      let cargoDoc = this.seaCargoDoc
      if (!(cargoDoc && cargoDoc.docType === 'MBL')) {
        const loading = getLoading4Cxt(this)
        try {
          cargoDoc = await getSeaMblByJobUuid({ 'jobUuid': this.jobUuid }).then(res => res.data)
        } finally {
          loading.close()
        }
      }
      if (cargoDoc) {
        this.form.actualShipperName = cargoDoc.shipperLine1
        let address = ''
        for (let i = 2; i <= 7; ++i) {
          if (address) {
            address += '\n'
          }
          address += cargoDoc['shipperLine' + i]
        }
        this.form.actualShipperAddress = address
        this.form.actualShipperPostalInfo = this.form.shipperPostalInfo
        this.form.actualShipperStreetNo = this.form.shipperStreetNo
        this.form.actualShipperStreetName = this.form.shipperStreetName
        this.form.actualShipperCodeForManifest = this.form.shipperIdNumber
        this.form.actualShipperPostalCode = this.form.shipperPostalCode
        this.form.actualShipperCountry = this.form.shipperCountry
        this.form.actualShipperCity = this.form.shipperCity
      }
    },
    async copyActualConsigneeOther() {
      let cargoDoc = this.seaCargoDoc
      if (!(cargoDoc && cargoDoc.docType === 'MBL')) {
        const loading = getLoading4Cxt(this)
        try {
          cargoDoc = await getSeaMblByJobUuid({ 'jobUuid': this.jobUuid }).then(res => res.data)
        } finally {
          loading.close()
        }
      }
      if (cargoDoc) {
        this.form.actualConsigneeName = cargoDoc.consigneeLine1
        let address = ''
        for (let i = 2; i <= 7; ++i) {
          if (address) {
            address += '\n'
          }
          address += cargoDoc['consigneeLine' + i]
        }
        this.form.actualConsigneeAddress = address
        this.form.actualConsigneePostalInfo = this.form.consigneePostalInfo
        this.form.actualConsigneeStreetNo = this.form.consigneeStreetNo
        this.form.actualConsigneeStreetName = this.form.consigneeStreetName
        this.form.actualConsigneeIdNumber = this.form.consigneeId
        this.form.actualConsigneeCodeForManifest = this.form.consigneePostalCode
        this.form.actualConsigneeCountry = this.form.consigneeCountry
        this.form.actualConsigneeCity = this.form.consigneeCity
      }
    },
    copyActualRecipient() {
      this.form.buyerName = this.form.actualConsigneeName
      this.form.buyerAddress = this.form.actualConsigneeAddress
      this.form.buyerPostalInfo = this.form.actualConsigneePostalInfo
      this.form.buyerStreetNo = this.form.actualConsigneeStreetNo
      this.form.buyerStreetName = this.form.actualConsigneeStreetName
      this.form.buyerIdNumber = this.form.actualConsigneeIdNumber
      this.form.buyerPostalCode = this.form.actualConsigneeCodeForManifest
      this.form.buyerCountry = this.form.actualConsigneeCountry
      this.form.buyerCity = this.form.actualConsigneeCity
    },
    copyActualShip() {
      this.form.sellerName = this.form.actualShipperName
      this.form.sellerAddress = this.form.actualShipperAddress
      this.form.sellerPostalInfo = this.form.actualShipperPostalInfo
      this.form.sellerStreetNo = this.form.actualShipperStreetNo
      this.form.sellerStreetName = this.form.actualShipperStreetName
      this.form.sellerIdNumber = this.form.actualShipperCodeForManifest
      this.form.sellerPostalCode = this.form.actualShipperPostalCode
      this.form.sellerCountry = this.form.actualShipperCountry
      this.form.sellerCity = this.form.actualShipperCity
    },
    showNameAddressDialog(title, nameKey, addressKey) {
      this.nameAddressDialog.title = title
      this.nameAddressDialog.nameKey = nameKey
      this.nameAddressDialog.addressKey = addressKey
      this.nameAddressDialog.value = this.form[nameKey] + '\n' + this.form[addressKey]
      this.nameAddressDialog.visible = true
    },
    finishNameAddress() {
      const { nameKey, addressKey, value } = this.nameAddressDialog
      const index = value.indexOf('\n')
      if (index > -1) {
        this.form[nameKey] = value.substring(0, index).trim()
        this.form[addressKey] = value.substring(index + 1).trim()
      } else {
        this.form[nameKey] = value.trim()
        this.form[addressKey] = ''
      }
      this.nameAddressDialog.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-title {
  display: flex;
  align-items: center;
}

.header-title {
  margin-right: 10px; /* 增加标题和按钮之间的间距，但不太远 */
  line-height: 24px;
  font-size: 18px;
  color: #333;
}

.custom-button {
  margin-left: 10px; /* 确保按钮与标题有适当间距 */
}

.form-section {
  flex: 1;
  padding: 10px;
  position: relative;
}

.vertical-line {
  width: 4px;
}

.title {
  position: relative;
}

.title::before {
  content: "";
  position: absolute;
  width: 4px;
  height: 100%;
  top: 0;
  left: -10px;
  background-color: #1f75d5;
}

.lable-blue ::v-deep {
  .el-form-item__label {
    color: #1F75D5 !important;
  }
}
</style>
